import { moduleProviderFactory } from 'core/providers';
import { MasterLayout } from 'core/layouts';
import { NotFound, DisplayError } from 'modules/root/pages';
import { isSome, getAppRouterState } from 'core/utils';
import { AppLogin, AppPasswordRecovery, PasswordChange, TwoStepAuthentication } from 'modules/membership/pages';
import packageJSON from '../package.json';
import devAppSettingsJSON from 'config/development/application-settings.json';
import proAppSettingsJSON from 'config/production/application-settings.json';
import stagAppSettingsJSON from 'config/staging/application-settings.json';

(function() {
	moduleProviderFactory.common.register({
		routes: [
			{
				name: 'master.app.membership.login',
				pattern: '/login',
				component: AppLogin,
			},
			{
				name: 'master.app.membership.password-change',
				pattern: '/password-change/:token?',
				component: PasswordChange,
			},
			{
				name: 'master.app.membership.two-step-authentication',
				pattern: '/two-step-authentication',
				component: TwoStepAuthentication,
			},
			{
				name: 'master.app.membership.password-recovery',
				pattern: '/password-recovery',
				component: AppPasswordRecovery,
			},
			{
				name: 'master',
				pattern: '',
				component: [MasterLayout],
				beforeEnter: (fromState, toState, routerStore) => {
					const { rootStore } = routerStore;
					rootStore.initialState = getAppRouterState('master.app.main.user.list');
					return Promise.resolve();
				},
				children: [
					{
						name: 'master.error',
						pattern: '/error',
						component: DisplayError,
						beforeEnter: (fromState, toState, routerStore) => {
							const {
								rootStore,
								rootStore: { errorStore },
							} = routerStore;
							if (!isSome(errorStore.errors) && !isSome(errorStore.internalException)) {
								routerStore.goTo(rootStore.initialState);
								return Promise.reject();
							}
							return Promise.resolve();
						},
					},
					{
						name: 'master.not-found',
						pattern: '/not-found',
						component: NotFound,
					},
				],
			},
		],
	});
	devAppSettingsJSON.currentVersion = packageJSON.version;
	proAppSettingsJSON.currentVersion = packageJSON.version;
	stagAppSettingsJSON.currentVersion = packageJSON.version;
})();
